import { useRestApiProvider } from "@jugl-web/rest-api";
import { UpdateTaskBoardPayload } from "@jugl-web/rest-api/tasks/models/TaskBoard/TaskBoardDto";
import { useCallback } from "react";

interface UseUpdateTaskBoardOptions {
  entityId: string;
}

export const useUpdateTaskBoard = ({ entityId }: UseUpdateTaskBoardOptions) => {
  const { tasksApi } = useRestApiProvider();

  const [updateBoardMutation, { isLoading: isUpdatingBoard }] =
    tasksApi.useUpdateTaskBoardMutation();

  const updateBoard = useCallback(
    (
      boardId: string,
      attributes: UpdateTaskBoardPayload,
      isOptimistic?: boolean
    ) =>
      updateBoardMutation({
        entityId,
        boardId,
        data: attributes,
        optimistic: isOptimistic,
      }),
    [entityId, updateBoardMutation]
  );

  return {
    updateBoard,
    isUpdatingBoard,
  };
};
